// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qP5T08hv18z1aP {
  display: flex;
  padding: var(--ds-space-200, 16px) var(--ds-space-0, 0);
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.qP5T08hv18z1aP:first-child {
  padding-top: var(--ds-space-0, 0);
}
.dQ9KlTz9dQ9pXr {
  display: flex;
  flex: 1 1 auto;
}
.ZScvrsQIlspu_S {
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: var(--ds-border-radius-100, 3px);
  background-size: cover;
}
.r6Mjj5blMtVybt {
  display: block;
  margin: auto var(--ds-space-100, 8px) auto var(--ds-space-100, 8px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.WqYuRFyMSUhfXQ {
  display: flex;
  flex: 0 0 auto;
}
.c8me1BwLz0CD1_ {
  margin: auto var(--ds-space-0, 0);
}
`, ""]);
// Exports
export var boardRow = `qP5T08hv18z1aP`;
export var boardRowLeftContainer = `dQ9KlTz9dQ9pXr`;
export var boardThumbnail = `ZScvrsQIlspu_S`;
export var boardName = `r6Mjj5blMtVybt`;
export var boardRowRightContainer = `WqYuRFyMSUhfXQ`;
export var boardDateClosed = `c8me1BwLz0CD1_`;
export default ___CSS_LOADER_EXPORT___;
